export const phonePlaceholder = '+7 000 000-00-00';
export const helpServiceChat = {
    href: 'https://support.mts.ru/mts_junior/otveti-na-voprosi/kto-mozhet-podklyuchit-mts-junior',
    text: 'К чату с поддержкой',
};
